
<div class="account-container">
    
    <div class="account-header">
        <h2>Account</h2>
    </div>

    <div class="profile-section">
        <div class="profile-img"><mat-icon>person</mat-icon>
</div>

        <div class="profile-info">
            <h3>{{username | titlecase}}</h3>
            <p>{{useremail}}</p>
        </div>
    </div>

    <div class="account-list">
        <div class="list-item" routerLink="/my-order">
            <span class="icon"><mat-icon>inventory_2</mat-icon> </span>
            <span class="text"> Orders</span>
            <span class="arrow">›</span>
        </div>

        <div class="list-item" routerLink="/useraddress">
            <span class="icon"><mat-icon>location_on</mat-icon></span>
            <span class="text"> Addresses</span>
            <span class="arrow">›</span>
        </div>

        <div class="list-item" routerLink="/setting">
            <span class="icon"> <mat-icon>settings</mat-icon>  </span>
            <span class="text"> Settings</span>
            <span class="arrow">›</span>
        </div>
    </div>

</div>
